module.exports = __webpack_public_path__ + "img/Pedometer.e0117a4f.png";